<template>
    <div id="filters" class="xl:w-1/6 lg:w-1/3 pl-0 pr-0 filter-small-screen" style="display: none; height: 520px; overflow-y: auto;">
        <div class="flex w-full mr-0 pr-0" style="height: 520px;">
            <div class="card w-full p-0">
                <div class="card-body p-0" style="min-height: 510px;">
                    <div class="flex">
                        <div class="offset-1 w-3/4 card-title mt-3 mb-1">
                            Filters <button type="button" class="btn btn-outline-light text-dark" @click="resetFilters">Reset</button>
                        </div>
                        <div class="cross-icon w-1/12 h2 pt-2 small-screen">
                            <i id='cross-filters' class='fas fa-times text-muted'></i>
                        </div>
                    </div>
                    <h5 class="ml-4"></h5>
                    <div class="accordion ml-1" id="accordionFirst">
                        <div class="card" v-for="(filter, name) in filters" v-bind:key="filter.id">
                            <div class="card-header" :id="`heading-${filter.id}`" style="background-color: white; padding-left: 5px; border-bottom: 0px;">
                                <div class="sm:w-5/6">
                                    <h2 class="mb-0">
                                        <button class="btn btn-block text-left font-weight-bold" type="button" aria-expanded="true" @click="chooseFilter(filter.id)">
                                            <div class="flec">
                                                <div class="sm:w-5/6 selected-filter">
                                                    <input type='hidden' :value="filter.id" />
                                                    <span>{{ name }}</span>
                                                </div>
                                            </div>
                                        </button>
                                    </h2>
                                </div>
                            </div>
                            <div v-for="(child, name) in filter.children" v-bind:key="child.id" id="collapseFirst" class="collapse show" :aria-labelledby="`heading-${filter.id}`" data-parent="#accordionFirst">
                                <calendar-filter :offset="10" :data="child" :name="name" v-on:change-filter="changeFilter" :selectedFilter="selectedFilter"></calendar-filter>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                filters: [],
                selectedFilter: null,
                windowWidth: window.innerWidth,
            }
        },
        mounted() {
            this.getFilters();
        },
        methods: {
            /** 
             * 
             * Get data
             * 
             */
            getFilters() {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/absences/calendar/get-filters`,
                    success: this.callbackFilters,
                });
            },
            /**
             * 
             * Callback
             * 
             */
            callbackFilters(event) {
                this.filters = event.filters;
            },
            /** 
             * 
             * Changing view
             * 
             */
            toggleSelected(filterID) {
                $(`#heading-${filterID}`).toggleClass('selected-filter-header');
                if ($(`#heading-${filterID}`).hasClass('selected-filter-header')) {
                    $(`#heading-${filterID}`).css("padding-left", "-=5");
                } else {
                    $(`#heading-${filterID}`).css("padding-left", "+=5");
                }
            },
            /** 
             * 
             * Events
             * 
             */
            changeFilter(filterID) {
                this.toggleSelected(filterID)
                this.toggleSelected(this.selectedFilter)
                this.selectedFilter = filterID;

                this.$emit('change-filter', filterID);
            },
            chooseFilter(filterID) {
                this.changeFilter(filterID);
            },
            resetFilters() {
                this.toggleSelected(this.selectedFilter);
                this.selectedFilter = null;
                this.$emit('change-filter', this.selectedFilter);
            },
        },
    }
</script>
